import { ID, Role } from 'src/types/common';
import {
  Campus,
  Class,
  Institution,
  Organization,
  Professor,
  Program,
} from 'src/types/institution';

export type ClientToken = {
  authToken: string;
  authTokenExpirationDate: string;
  clientId: ID;
  lastAccess: string;
};

export type ClientOAuth = {
  clientOauthId: ID;
  clientId: ID;
  oauthEmail: string;
  created: string;
  lastUsed: string;
  oauthApp: string;
  oauthId: ID;
};

export type ClientWebAuthn = {
  clientWebauthnId: ID;
  clientId: ID;
  created: string;
  lastUsed: string;
  name?: string;
  publicKey: string;
};

export type ClientInformation = {
  campusId?: ID;
  classId?: ID;
  clientId?: ID;
  created?: string;
  email: string;
  firstName?: string | null;
  image?: string | null;
  imageId?: number;
  institutionId?: ID;
  isEmailVerified: boolean;
  lastAccess: string;
  lastName?: string | null;
  oauths: ClientOAuth[];
  phone?: string;
  programId?: ID;
  role: Role;
  clientType: ClientType;
  timezone: string;
  token: ClientToken;
  webauthns: ClientWebAuthn[];
  organization: Organization | null;
  professor: Professor;
  institution: Institution;
  managedInstitution?: Institution | null;
  program: Program;
  campus: Campus;
  class: Class;
  metadata?: any;
};

export enum ClientType {
  Student = 'STUDENT',
  CreatorFaculty = 'CREATOR_FACULTY',
  CreatorOrgAdmin = 'CREATOR_ORGANIZATION_ADMIN',
  CreatorInstitutionAdmin = 'CREATOR_INSTITUTION_ADMIN',
  CreatorOrgRepresentative = 'CREATOR_ORGANIZATION_REPRESENTATIVE',
}
